import { Component } from '@angular/core';

/** A error page component to be used when a path cannot be matched by the router. */
@Component( {
    selector: 'of-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
} )
export class NotFoundComponent { }
